import React from 'react';
import HeadLineThird from '../../atoms/HeadLineThird';
import ReservationAdvanceCard from '../../molecules/ReservationAdvanceCard';

export interface ReservationCountList {
  label: string;
  count: number;
}

export interface ReservationCountProps {
  onlineReservationlist: ReservationCountList[];
  crewReservationlist: ReservationCountList[];
}

const ReservationCount: React.FC<ReservationCountProps> = ({ onlineReservationlist, crewReservationlist }) => {
  return (
    <div className='u-mr24'>
      <HeadLineThird text='予約数' className='headline-4 u-mb8' data-testid='reservation-count--title' />
      <div className='u-flex'>
        <ReservationAdvanceCard title='WEB' itemList={onlineReservationlist} />
        <ReservationAdvanceCard title='クルー' itemList={crewReservationlist} />
      </div>
    </div>
  );
};
export default ReservationCount;
